export const positiveData = {
  chart: [
    { name: "PPT", Positive: 8000 },
    { name: "CB", Positive: 6000 },
    { name: "Paid", Positive: 1000 },
    { name: "OTS", Positive: 5000 },
    { name: "Third Party", Positive: 400 },
    { name: "BP", Positive: 6700 },
  ],
  keys: ["Positive"],
  colors: ["#00B247"],
};

export const negativeData = {
  chart: [
    { name: "RTP", Negative: 8000 },
    { name: "EXP", Negative: 6000 },
    { name: "NC", Negative: 1000 },
    { name: "Ringing", Negative: 5000 },
    { name: "Out Of Coverage", Negative: 400 },
    { name: "No Number", Negative: 6700 },
    { name: "Doesn’t Exist", Negative: 6700 },
    { name: "Wrong No. ", Negative: 6700 },
  ],
  keys: ["Negative"],
  colors: ["#E94E21"],
};

export const ddrData = {
  chart: [
    {
      name: "Jan",
      "Week 1": 100,
      "Week 2": 200,
      "Week 3": 150,
      "Week 4": 80,
    },
    {
      name: "Feb",
      "Week 1": 120,
      "Week 2": 190,
      "Week 3": 130,
      "Week 4": 100,
    },
    {
      name: "Mar",
      "Week 1": 100,
      "Week 2": 200,
      "Week 3": 150,
      "Week 4": 80,
    },
    {
      name: "April",
      "Week 1": 120,
      "Week 2": 190,
      "Week 3": 130,
      "Week 4": 100,
    },
    {
      name: "May",
      "Week 1": 100,
      "Week 2": 200,
      "Week 3": 150,
      "Week 4": 80,
    },
    {
      name: "June",
      "Week 1": 120,
      "Week 2": 190,
      "Week 3": 130,
      "Week 4": 100,
    },
  ],
  keys: ["Week 1", "Week 2", "Week 3", "Week 4"],
  colors: ["#00B247", "#00B247", "#00B247", "#00B247"],
};

export const intensityData = {
  chart: [
    { name: "Case 1", Total: 100 },
    { name: "Case 2", Total: 200 },
    { name: "Case 3", Total: 300 },
    { name: "Case 4", Total: 400 },
    { name: "Case 5", Total: 550 },
    { name: "Case 6", Total: 650 },
    { name: "Case 7", Total: 750 },
    { name: "Case 8", Total: 850 },
    { name: "Case 9", Total: 950 },
    { name: "Case 10", Total: 1000 },
    { name: "Case 11", Total: 1100 },
    { name: "Case 12", Total: 1200 },
    { name: "Case 13", Total: 1300 },
  ],
  keys: ["Total"],
  colors: ["#00B247"],
};

export const drrProductivityData = {
  chart: [
    { name: "Jan", Total: 80 },
    { name: "Feb", Total: 60 },
    { name: "Mar", Total: 100 },
    { name: "April", Total: 50 },
    { name: "May", Total: 67 },
    { name: "June", Total: 67 },
    { name: "July", Total: 70 },
    { name: "August", Total: 100 },
  ],
  keys: ["Total"],
  colors: ["#FFB74B"],
};
